const checkAll = () => {
 const DATA_GROUP = `check-group`;
 const DATA_CHECK_ALL_WRAP = `check-all-wrap`;
 const DATA_NO_CHECK_ALL = `no-check-all`;

 const SELECTOR_WRAPPER = `
 table:has(thead .check-all),
 [class*=-group]:has(.check-all),
 [data-${DATA_GROUP}]:has(.check)
 `;
 const SELECTOR_CHECKBOX = `[type="checkbox"].check`;
 const SELECTOR_CHECK_ALL = `${SELECTOR_CHECKBOX}.check-all`;
 const SELECTOR_BTN_CHECK_ALL = `.btn-check-all`;

 const handleCheckAllInput = (allButton, checks) => {
 checks.forEach((check) => {
 check.checked !== allButton.checked &&
 (check.checked = allButton.checked);
 });
 };

 const handleCheckInput = (allButton, checks) => {
 allButton.checked = [...checks].every((check) => check.checked);
 };

 const handleInput = (event) => {
 const { target } = event;

 if (
 !target.matches(SELECTOR_CHECKBOX) &&
 !target.matches(SELECTOR_CHECK_ALL)
 )
 return;

 const wrapper = target.closest(SELECTOR_WRAPPER);
 const allButton = wrapper?.querySelector(SELECTOR_CHECK_ALL);
 const groupChecks =
 allButton &&
 document.querySelectorAll(
 `[data-${DATA_GROUP}~=${allButton.getAttribute(`data-${DATA_GROUP}`)}] ${SELECTOR_CHECKBOX}:not(${SELECTOR_CHECK_ALL}, [data-${DATA_NO_CHECK_ALL}])`,
 );
 const checks = allButton && [
 ...wrapper.querySelectorAll(
 `${SELECTOR_CHECKBOX}:not(${SELECTOR_CHECK_ALL}, [data-${DATA_NO_CHECK_ALL}])`,
 ),
 ...(groupChecks || []),
 ];

 if (!wrapper || !allButton || !checks) return;

 if (!event.isTrusted) {
 handleCheckAllInput(allButton, checks);
 return;
 }

 target.matches(SELECTOR_CHECK_ALL)
 ? handleCheckAllInput(target, checks)
 : handleCheckInput(allButton, checks);
 };

 const handleCheckAllButton = (e) => {
 const allButton = e.target.closest(SELECTOR_BTN_CHECK_ALL);
 const wrapData = allButton?.getAttribute(`data-${DATA_CHECK_ALL_WRAP}`);
 const targetWraps = document.querySelectorAll(
 `[data-${DATA_CHECK_ALL_WRAP}~="${wrapData}"]:not(${SELECTOR_BTN_CHECK_ALL})`,
 );

 if (!allButton || !targetWraps) return;

 targetWraps.forEach((wrap) => {
 wrap.querySelectorAll(`[type=checkbox]`).forEach((check) => {
 check.checked = true;
 });
 });
 };

 const applyCheckState = () => {
 document
 .querySelectorAll(`${SELECTOR_CHECK_ALL}:checked`)
 .forEach((target) => {
 target.dispatchEvent(
 new Event(`input`, {
 bubbles: true,
 }),
 );
 });
 };

 const initialize = () => {
 document.body.addEventListener(`input`, handleInput);
 document.body.addEventListener(`click`, handleCheckAllButton);

 applyCheckState();
 };

 initialize();

 checkAll.update = applyCheckState;

 checkAll.cleanup = () => {
 document.body.removeEventListener(`input`, handleInput);
 document.body.removeEventListener(`click`, handleCheckAllButton);
 };
};

export default checkAll;
